import React from 'react';
import TvPackage from './tvPackage';
import TranslationService from "../../service/TranslationService";
import {CHANNELS, INCLUDED_PACKAGES, INCLUDED_REGIONAL_CHANNELS, DVBT_OFFER_CHANNELS, TV_CHANNELS, AVAILABLE} from "../../language-content/keys";

const includedTvPackages = (props) => {
    if (!props.tvPackages || props.tvPackages.length === 0)
        return null;
    if (!props.dvbtTvPackages || props.dvbtTvPackages.length === 0)
        return null;

    return (
        <section id="included-packages" className="bg-gray-15 pb-5 no-packages">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h4 className="serif-regular mb-2"> {TranslationService.translate(INCLUDED_PACKAGES, props.lang)}:&nbsp;
                            <br className="d-block d-md-none"/>
                            {props.tvPackages.map(tp => {
                                return (<a className={"text-uppercase text-underline text-center mt-2 color-blue"}
                                onClick={() => props.selectDisplayTvPackage(tp)}>
                                {tp.channelSize} {TranslationService.translate(CHANNELS, props.lang)}
                            </a>)
                            })}
                        </h4>
                    </div>                    

                    {/* <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <div
                            className="row row-cols-2 row-cols-md-3 d-flex flex-fill justify-content-center">

                            {props.tvPackages.map(tp => {
                                return (<TvPackage package={tp} wrapperClassName={"package-wrapper"}
                                                   selectDisplayTvPackage={(p) => props.selectDisplayTvPackage(p)}
                                                   lang={props.lang}/>)
                            })}

                        </div>
                    </div> */}

                       
                    <div className="col-12 text-center">
                        <small>
                            {TranslationService.translate(INCLUDED_REGIONAL_CHANNELS, props.lang)}
                        </small>
                    </div>

                    {displayDVBTPackages()}

                </div>
            </div>
        </section>
    );

    function displayDVBTPackages() {
        var tvPackagesSize = props.tvPackages.map(tp => {
            return (tp.channelSize)
        })

        var dvbtPackagesSize = props.dvbtTvPackages.map(tp => {
            return (tp.channelSize)
        })
        if(props.technologyType == 'CABLE' && (tvPackagesSize.toString() != dvbtPackagesSize.toString())){
            return (<div className="col-12 text-center mt-3">
                <small>
                    {TranslationService.translate(DVBT_OFFER_CHANNELS, props.lang)}
                    &nbsp;
                    <br className="d-block d-md-none"/>
                    {props.dvbtTvPackages.map(tp => {
                        return (
                            <a className={"text-uppercase text-underline text-center mt-2 color-blue"}
                                   onClick={() => props.selectDisplayDVBTTvPackage(tp)}>
                            {/*{tp.channelSize} */}
                            {TranslationService.translate(TV_CHANNELS, props.lang)}

                        </a>)
                    })}
                    &nbsp;{TranslationService.translate(AVAILABLE, props.lang)}
                </small>
            </div>)
        }
    }
};

export default includedTvPackages;
